// extracted by mini-css-extract-plugin
export default {"input-view":"input_input-view__uztqv"};